module.exports = __webpack_public_path__ + "static/media/randomlo.8d998b45.jpg";